import type { OrganizationInvitationSentResponseAccessResponseStatusEnum } from '@api-client/api'
import { useTranslation } from 'react-i18next'

import { StatusChip, type StatusIntent } from './StatusChip'

type Status = OrganizationInvitationSentResponseAccessResponseStatusEnum

const INVITATION_INTENT: Record<Status, StatusIntent> = {
	ACCEPTED: 'success',
	DECLINED: 'danger',
	PENDING: 'info',
}

interface Props {
	status: Status
}

const InvitationStatusChip: React.FC<Props> = ({ status }) => {
	const { t } = useTranslation()
	const label =
		status === 'ACCEPTED'
			? t('complete')
			: status === 'DECLINED'
				? t('declined')
				: t('open')
	return <StatusChip intent={INVITATION_INTENT[status]} label={label} />
}

export { InvitationStatusChip }
